import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
// import BoardHeader from "./BoardHeader";
// import BoardMenu from "./BoardMenu";
// import Footer from "./Footer";
import "../../resources/styles/board.css";
import "../../resources/styles/boardpro.css";
import MessageManager from "../utils/MessageManager";
import { CONSTANT } from "../../utils/Constant";
import Topbar from "../../pages/global/Topbar";
import SidebarMenuWrap from "../../pages/global/Sidebar";
import { useApp } from "../../hooks/useApp";
import { useSidebarData } from "../../pages/global/SidebarDataContext";
import { Dashboard } from "@mui/icons-material";
import { CssBaseline, ThemeProvider } from "@mui/material";

import { ColorModeContext, useMode } from "../../theme";
import Loading from "../utils/Loading";

/*****************************************************************************
 * @description componente template - board layout
 *
 ****************************************************************************/
const BoardLayout = (props) => {
  const {
    authInfo,
    isLoading,
    loading,
    authenticate,
    errorMsg,
    resetErrorMsg,
    successMsg,
    resetSuccessMsg,
    isEmbedded,
  } = useApp();
  const { toggled, setToggled, broken } = useSidebarData();
  const [isSidebar, setIsSidebar] = useState(true);

  const [theme, colorMode] = useMode();
  const navigate = useNavigate();

  // validate pathname
  let { pathname } = useLocation();
  const specialRoutes = ["/board/authoritiesxrole"];
  const finalPathName = specialRoutes.find((r) => pathname.startsWith(r));
  if (finalPathName) {
    pathname = finalPathName;
  }

  if (!authenticate) {
    // console.log(authenticate);
    return <Navigate to="/" />;
  }

  //set tittle
  document.title = "CRM";

  if (isEmbedded) {
    return (
      <ColorModeContext.Provider value={colorMode}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <main className="content content--embedded">
            <Outlet />
          </main>
        </ThemeProvider>
      </ColorModeContext.Provider>
    );
  }

  return (
    <>
      <ColorModeContext.Provider value={colorMode}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          {/* <Dashboard /> */}
          <div className="app">
            <SidebarMenuWrap /* isSidebar={isSidebar}  */ />
            <main className="content">
              {broken && !toggled && (
                <MenuOutlinedIcon
                  onClick={() => setToggled(!toggled)}
                  sx={{
                    position: "absolute",
                    left: "20px",
                    top: "20px",
                    cursor: "pointer",
                    zIndex: 10,
                  }}
                />
              )}
              <Topbar setIsSidebar={setIsSidebar} />
              <Outlet />
              {/* <Footer footerType="admin" /> */}
            </main>
          </div>
          {/* <Footer footerType="admin" /> */}
        </ThemeProvider>
      </ColorModeContext.Provider>
    </>
  );
};
export default BoardLayout;
